core.factory('core.baseModel', ['$rootScope',
    function($rootScope) {

        function BaseModel() {

        	this.itemsPerPageOptions = [ 5, 10, 20, 50 ];
        	
    	    this.broadcastOperationSucceeded = function() {
    	    	$rootScope.$broadcast(Event.NOTIFICATION, new NotificationVO(Enum.NOTIFICATION_TYPE.SUCCESS, 'T.SYSTEM.NOTIFICATION.OPERATION_SUCCEEDED'));
    	    };
    	
    	    this.broadcastOperationFailed = function() {
    	    	$rootScope.$broadcast(Event.NOTIFICATION, new NotificationVO(Enum.NOTIFICATION_TYPE.ERROR, 'T.SYSTEM.NOTIFICATION.OPERATION_FAILED'));
    	    };
        }

        return new BaseModel();
    }
]);
